/* Segmented Bowl Designer — help assistant, as a floating chat bubble.
 *
 * A launcher button bottom-right; click it and a panel opens. The question goes
 * to the licence Worker, which holds the Anthropic key and answers from the user
 * guide. NOTHING about the key or the model lives here: this file is public, and
 * anything in it is readable by anyone who opens the page source.
 *
 * It answers questions about the app. It cannot see or change a design — the
 * Worker's system prompt says so, and this file gives it no way to.
 *
 * Deliberately NOT in the app bundle (src/), the same call as bowl-gate.js:
 * this is website-only, and src/ is shared with the desktop build.
 */
(function () {
  'use strict';

  // same Worker the Acheck online app calls — verified live 2026-08-03
  var ENDPOINT = 'https://areaclosure-license.drawingroom.workers.dev/bowl/ask';
  var MAX_CHARS = 600;

  var mount = document.getElementById('bowl-assistant');
  if (!mount) return;
  if (mount.dataset.endpoint) ENDPOINT = mount.dataset.endpoint;

  // history is kept in memory only — nothing is stored, nothing follows the
  // visitor between visits
  var history = [];
  var busy = false;
  var greeted = false;

  mount.innerHTML =
    '<button class="ba-launch" id="ba-launch" type="button"' +
      ' aria-expanded="false" aria-controls="ba-panel">' +
      '<span class="ba-launch-icon" aria-hidden="true">?</span>' +
      '<span class="ba-launch-text">Ask about the app</span>' +
    '</button>' +
    '<div class="ba-panel" id="ba-panel" role="dialog" aria-modal="false"' +
      ' aria-label="Ask about the Segmented Bowl Designer" hidden>' +
      '<div class="ba-head">' +
        '<div>' +
          '<span class="ba-title">Ask about the app</span>' +
          '<span class="ba-sub">Answers come from the user guide.</span>' +
        '</div>' +
        '<button class="ba-x" id="ba-x" type="button" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="ba-log" id="ba-log" role="log" aria-live="polite"></div>' +
      '<form class="ba-form" id="ba-form">' +
        '<label class="ba-vh" for="ba-q">Your question</label>' +
        '<input class="ba-input" id="ba-q" type="text" autocomplete="off"' +
          ' maxlength="' + MAX_CHARS + '" placeholder="e.g. How do I add a lid?">' +
        '<button class="ba-send" id="ba-send" type="submit">Ask</button>' +
      '</form>' +
      '<p class="ba-foot">It explains how the app works — it can’t see or change your design.</p>' +
    '</div>';

  var launch = mount.querySelector('#ba-launch');
  var panel = mount.querySelector('#ba-panel');
  var closeBtn = mount.querySelector('#ba-x');
  var log = mount.querySelector('#ba-log');
  var form = mount.querySelector('#ba-form');
  var input = mount.querySelector('#ba-q');
  var send = mount.querySelector('#ba-send');

  // textContent, never innerHTML — the answer is model output and the question
  // is visitor input; neither is ever parsed as markup
  function bubble(who, text, cls) {
    var row = document.createElement('div');
    row.className = 'ba-row ba-' + who + (cls ? ' ' + cls : '');
    var b = document.createElement('div');
    b.className = 'ba-bubble';
    b.textContent = text;
    row.appendChild(b);
    log.appendChild(row);
    log.scrollTop = log.scrollHeight;
    return b;
  }

  function open() {
    panel.hidden = false;
    mount.classList.add('ba-open');
    launch.setAttribute('aria-expanded', 'true');
    if (!greeted) {
      greeted = true;
      bubble('bot', 'Ask me anything about how the Segmented Bowl Designer works.');
    }
    input.focus();
  }

  function close() {
    panel.hidden = true;
    mount.classList.remove('ba-open');
    launch.setAttribute('aria-expanded', 'false');
    launch.focus();
  }

  launch.addEventListener('click', function () {
    panel.hidden ? open() : close();
  });
  closeBtn.addEventListener('click', close);

  // Escape closes it, but only while it is open — otherwise this would swallow
  // Escape from the app underneath
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });

  function setBusy(on) {
    busy = on;
    send.disabled = on;
    input.disabled = on;
    send.textContent = on ? '…' : 'Ask';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var q = input.value.trim();
    if (!q) return;

    bubble('you', q);
    input.value = '';
    setBusy(true);
    var thinking = bubble('bot', 'Looking that up…', 'ba-wait');

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: q, history: history })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        thinking.parentNode.remove();
        if (d && d.ok && d.answer) {
          bubble('bot', d.answer);
          history.push({ role: 'user', text: q });
          history.push({ role: 'assistant', text: d.answer });
          if (history.length > 6) history = history.slice(-6);
        } else {
          bubble('bot', (d && d.msg) || 'Something went wrong. Please try again.', 'ba-err');
        }
      })
      .catch(function () {
        thinking.parentNode.remove();
        bubble('bot', 'Could not reach the assistant. Please try again.', 'ba-err');
      })
      .then(function () {
        setBusy(false);
        input.focus();
      });
  });

  /* The page has its own sticky price bar (#sbd-sticky, fixed to the bottom,
     z-index 60) that slides up once the hero scrolls off. Left alone, the bubble
     would sit on top of it. Watch that bar's own `show` class and lift the bubble
     clear — a class watch rather than a scroll listener, so the two can never
     disagree about whether the bar is up. */
  var bar = document.getElementById('sbd-sticky');
  if (bar && 'MutationObserver' in window) {
    var lift = function () {
      mount.classList.toggle('ba-lifted', bar.classList.contains('show'));
    };
    new MutationObserver(lift).observe(bar, { attributes: true, attributeFilter: ['class'] });
    lift();
  }
})();
